<template>
  <v-dialog v-model="dialog" width="800">
    <v-card class="pa-10">
      <v-icon x-large class="v-icon-delete">
        mdi-delete-alert-outline
      </v-icon>

      <div v-if="currentVideoItem">
        <v-card-title class="text-h6 pp-center">
          Are you sure you want to delete the video of "{{ currentVideoItem.title }}"?
        </v-card-title>

        <p class="pp-center pb-5">
          This video will be deleted immediately. You can't undo this action.
        </p>
      </div>

      <div v-else>
        <UnavailableContent />
      </div>

      <Loading v-if="videoItemLoading" />

      <ConfirmCancelButtons
          :item="currentVideoItem"
          :confirm-disabled="videoItemLoading"
          confirm-text="Delete Video"
          :confirm-action="deleteItemConfirm"
          cancel-class="mr-5"
          :cancel-action="closeDialog"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import ConfirmCancelButtons from "@/components/common/ConfirmCancelButtons";
import Loading from "@/components/common/Loading";
import { mapActions, mapGetters, mapState } from "vuex";
import UnavailableContent from "@/components/common/UnavailableContent";

export default {
  name: "VideoDelete",
  components: {
    UnavailableContent, ConfirmCancelButtons, Loading,
  },
  computed: {
    ...mapState(['currentVideoItem']),
    ...mapGetters(['videoApiError', 'openDialog', 'currentVideoItem', 'videoItemLoading']),
    dialog: {
      get () {
        return this.openDialog === 'videoDelete';
      },
      set(value) {
        this.setOpenDialog(value);
      },
    },
  },
  methods: {
    ...mapActions(['deleteVideo', 'clearVideoItems', 'setOpenDialog', 'closeOpenDialog']),
    closeDialog() {
      this.closeOpenDialog();
      this.clearVideoItems();
    },
    async deleteItemConfirm() {
      const deleted = await this.deleteVideo(this.currentVideoItem);
      if (deleted) {
        this.closeOpenDialog();
      }
    },
  },
};
</script>
